import Service from "./Service";

const resource = 'api/urgencia-triage-historia';

export default {
    store(data) {
        return Service.post(`${resource}/store`, data);
    },
}